import type { ActorRole } from '../../types/prioritization/roles';
import { roleDefinitions } from '../../types/prioritization/roles';

interface RoleBadgeProps {
  role: ActorRole;
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
  showLabel?: boolean;
}

export function RoleBadge({ 
  role, 
  size = 'md', 
  showIcon = true, 
  showLabel = true 
}: RoleBadgeProps) {
  const roleDef = roleDefinitions[role];
  
  const sizeClasses = {
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-1',
    lg: 'text-base px-4 py-2'
  };
  
  const iconSizes = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-lg'
  };
  
  return (
    <span 
      className={`inline-flex items-center gap-1.5 rounded-full font-medium ${sizeClasses[size]} ${roleDef.color} ${roleDef.bgColor} ${roleDef.borderColor} border`}
      title={roleDef.description}
    >
      {showIcon && <span className={iconSizes[size]}>{roleDef.icon}</span>}
      {showLabel && <span>{roleDef.name}</span>}
    </span>
  );
}

